import { FC, useEffect, useState } from "react"
import { CourseContent, Quiz } from "interfaces/courses"
import CourseButton from "@cs/components/courses/course-button/CourseButton"
import { useTranslation } from "next-i18next"
import { NextSeo } from "next-seo"
import { IoIosArrowBack } from "react-icons/io"
import Link from "next/dist/client/link"
import CourseSidebar from "@cs/components/courses/course-sidebar/CourseSidebar"
import styles from "./CoursePage.module.scss"
import QuizContent from "@cs/components/courses/chapter-content/QuizContent"
import { useRouter } from "next/router"
import { populateStore } from "util/populatei18nStore"

export interface QuizPageProps {
  quiz: Quiz
  course: CourseContent
  nextSectionSlug: string
}
const QuizPage: FC<QuizPageProps> = ({ quiz, course, nextSectionSlug }) => {
  const { t } = useTranslation("courses")
  const [render, setRender] = useState(false)
  const router = useRouter()
  const difficulty = quiz.difficulty

  useEffect(() => {
    (async () => {
      setRender(false)
      Promise.all([
        populateStore(router.locale as string, "courses", "en"),
        populateStore(router.locale as string, "footer", "en")
      ]).then(() => {
        setRender(true)
      })
    })()

  }, [router])

  if ( !render ) return  null

  return (
    <main className={styles.container}>
      <NextSeo title={quiz.title} />

      <Link href={`/new-courses/${course.slug}`}>
        <CourseButton light underline className={styles.backButton}>
          <IoIosArrowBack />
          {t("back-to-course", { course: course.title })}
        </CourseButton>
      </Link>

      <CourseSidebar
        courseId={course.id}
        courseSlug={course.slug}
        courseTitle={course.title || ""}
        chapters={course.chaptersData[difficulty] || []}
        difficulty={difficulty}
      />

      <QuizContent course={course} quiz={quiz} nextSection={nextSectionSlug} />
    </main>
  )
}

export default QuizPage
